<form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P271F0001">
    <div class="form-row">
        <div class="form-field">
            <p-dropdown formControlName="origen" appendTo="body" [options]="cuestionarios" optionLabel="label" optionValue="value" 
                placeholder="Seleccione el cuestionario origen" class="w-100" [loading]="loading" appPermissionControl="P271K0001"></p-dropdown>
            <label>Origen</label>
        </div>
    </div>
    <div class="form-row">
        <div class="form-field">
            <input pInputText formControlName="destino" placeholder="Clave Cuestionario Destino" class="w-100" appPermissionControl="P271K0002">
            <label>Destino</label>
        </div>
    </div>

    <div class="button-section mt-3">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid" appPermissionControl="P271B0001">
            <mat-icon>content_copy</mat-icon>
            Copiar
        </button>
    </div>
</form>